module.exports = __webpack_public_path__ + "static/media/404.a41a6c81.jpg";